import React from 'react';
import PropTypes from 'prop-types';

export default class IndexTablePagerItem extends React.Component {

    static propTypes = {
        active: PropTypes.bool,
        advanced: PropTypes.bool,
        selected: PropTypes.bool
    }

    static defaultProps = {
        active: true,
        advanced: false,
        selected: false
    }

    onClick = e => {
        if (this.props.active) {
            this.props.onClick(e)
        }
    }

    render() {
        const rootClassNames = ['index-table-pager-item']

        if (this.props.active === false) {
            rootClassNames.push('index-table-pager-item--inactive')
        }

        if (this.props.advanced) {
            rootClassNames.push('index-table-pager-item--advanced')
        }

        if (this.props.selected) {
            rootClassNames.push('index-table-pager-item--selected')
        }

        return (
            <div className={rootClassNames.join(' ')} onClick={this.onClick}>
                {this.props.children}
            </div>
        )
    }
}